import React, { useEffect, useRef, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import DiscussForm from '../components/DiscussForm';
import projects from '../data/ProjectsData';

import './LandownerShare.css';
import './Project-Details.css';
import './Home.css';
import './Projects.css';

const ProjectDetails = () => {
    const { id } = useParams();
    const project = projects.find((p) => p.id === id);
    const [theme, setTheme] = useState('light');

    const amenitiesRef = useRef(null);
    const specsRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const checkAndClose = (ref, collapseId) => {
                if (!ref.current) return;

                const rect = ref.current.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                if (rect.bottom < 0 || rect.top > windowHeight) {
                    const collapseElement = document.getElementById(collapseId);
                    if (collapseElement?.classList.contains('show')) {
                        const bsCollapse = window.bootstrap.Collapse.getInstance(collapseElement) ||
                            new window.bootstrap.Collapse(collapseElement);
                        bsCollapse.hide();
                    }
                }
            };

            checkAndClose(amenitiesRef, 'collapseAmenities');
            checkAndClose(specsRef, 'collapseSpecifications');
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!project) {
        return (
            <div className="container py-5 text-center">
                <h2 className="text-danger">Project not found</h2>
            </div>
        );
    }

    return (
        <div className="projects-main">
            {/* Hero Section */}
            <div className="about-hero">
                <div className="about-hero-inner d-flex justify-content-center align-items-center text-center">
                    <div>
                        <h1 className="syne-title">{project.title}<span className="text-rose">.</span></h1>
                        <p>
                            <Link to="/" className="text-dark text-decoration-none">Home</Link> /{" "}
                            <Link to="/projects" className="text-dark text-decoration-none">Projects</Link> /{" "}
                            <span className="text-rose">{project.title}</span>
                        </p>
                    </div>
                </div>
            </div>

            {/* Project About */}
            <div className="landowner-about container-fluid py-4">
                <div className="landowner-about-inner container py-4">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-10 my-2 d-flex justify-content-center">
                            <img src={project.image} alt={project.title} className="img-fluid shadow-sm rounded" />
                        </div>
                        {/* <div className="col-lg-6 my-2 px-2 py-1 d-flex justify-content-center align-items-center">
                            <div className="landowner-about-one-right dark-white-text">
                                <h4 className="syne-title fs-2 mb-2">{project.title}<span className="text-rose">.</span></h4>
                                {project.description?.map((para, index) => (
                                    <div key={index} dangerouslySetInnerHTML={{ __html: para }} />
                                ))}
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            {/* Gallery */}
            {project.gallery?.length > 0 && (
                <div className="container py-4">
                    <h1 className="syne-title text-center mb-4">Gallery<span className="text-rose">.</span></h1>
                    <div className="row justify-content-center">
                        {project.gallery.map((img, index) => (
                            <div className="col-md-3 col-6 my-2" key={index}>
                                <img src={img} alt={`gallery-${index}`} className="img-fluid rounded shadow-sm" />
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {/* Project Overview Cards */}
            <div className='container-fluid project-overiew bg-light'>
                {project.project_overview?.length > 0 && (
                    <div className="container py-4">
                        <h1 className="syne-title text-center mb-2">Project Overview<span className="text-rose">.</span></h1>
                        <div className='row justify-content-center'>
                            <div className='col-lg-8'>
                                <p className='text-dark text-center'>{project.description}</p>
                            </div>
                        </div>
                        <div className="row">
                            {project.project_overview.map((item, index) => (
                                <div className="col-md-4 col-lg-3 col-6 my-2" key={index}>
                                    <div className={`card over-card h-100 text-center p-3 border-0 shadow-sm`}>
                                        <div className="mb-3">
                                            <i className={`${item.icon} text-rose fa-2x`}></i>
                                        </div>
                                        <div className="card-body p-1">
                                            <h6 className="card-title fw-bold">{item.title}</h6>
                                            <p className="card-text mb-0">{item.value}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>



            {/* Amenities Accordion */}
            <div ref={amenitiesRef} className={`container-fluid py-4 amenity-main ${theme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}`}>
                {project.amenities?.length > 0 && (
                    <div className="container">
                        <div className="accordion" id="amenitiesAccordion">
                            <div className={`accordion-item border-0 shadow-sm ${theme === 'dark' ? 'bg-dark text-light' : 'bg-white text-dark'}`}>
                                <h2 className="accordion-header" id="headingAmenities">
                                    <button
                                        className={`accordion-button ${theme === 'dark' ? 'bg-dark text-light' : 'bg-white text-dark'} collapsed`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseAmenities"
                                        aria-expanded="false"
                                        aria-controls="collapseAmenities"
                                    >
                                        <h1 className="syne-title mb-0 w-100">Amenities<span className="text-rose">.</span></h1>
                                    </button>
                                </h2>
                                <div
                                    id="collapseAmenities"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingAmenities"
                                    data-bs-parent="#amenitiesAccordion"
                                >
                                    <div className={`accordion-body px-3 ${theme === 'dark' ? 'bg-dark text-light' : 'bg-white text-dark'}`}>
                                        <div className="row">
                                            {project.amenities.map((item, index) => (
                                                <div className="col-lg-3 col-md-4 col-6 my-2" key={index}>
                                                    <div className={`card amenity-card h-100 text-center p-2 border-0 shadow-sm ${theme === 'dark' ? 'bg-secondary text-light' : 'bg-light text-dark'}`}>
                                                        <div className="card-icon">
                                                            {item.icon && <i className={`${item.icon} text-rose me-2 fa-2x`}></i>}
                                                        </div>
                                                        <div className="card-body p-1">
                                                            <h6 className="card-title">{item.name}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Specifications Accordion */}
            <div ref={specsRef} className={`container-fluid py-4 amenity-main ${theme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}`}>
                {project.specifications?.length > 0 && (
                    <div className="container">
                        <div className="accordion" id="specsAccordion">
                            <div className={`accordion-item border-0 shadow-sm ${theme === 'dark' ? 'bg-dark text-light' : 'bg-white text-dark'}`}>
                                <h2 className="accordion-header" id="headingSpecifications">
                                    <button
                                        className={`accordion-button ${theme === 'dark' ? 'bg-dark text-light' : 'bg-white text-dark'} collapsed`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSpecifications"
                                        aria-expanded="false"
                                        aria-controls="collapseSpecifications"
                                    >
                                        <h1 className="syne-title mb-0 w-100">Specifications<span className="text-rose">.</span></h1>
                                    </button>
                                </h2>
                                <div
                                    id="collapseSpecifications"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSpecifications"
                                    data-bs-parent="#specsAccordion"
                                >
                                    <div className="accordion-body px-3">
                                        <div className="row">
                                            {project.specifications.map((spec, index) => (
                                                <div className="col-md-4 col-6 text-center mb-3" key={index}>
                                                    <div className={`card h-100 p-3 border-0 shadow-sm amenity-card ${theme === 'dark' ? 'bg-secondary text-light' : 'bg-light text-dark'}`}>
                                                        <i className={`${spec.icon} mb-2 text-rose`} style={{ fontSize: "2rem" }}></i>
                                                        <h6 className="mb-1 fw-bold">{spec.title}</h6>
                                                        <p className="mb-0 text-secondary">{spec.content}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Google Map */}
            {project.google_map && (
                <div className="container-fluid px-0 my-4">
                    <iframe
                        src={project.google_map}
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        title="Google Map"
                    ></iframe>
                </div>
            )}

            {/* Contact Form */}
            <DiscussForm />
        </div>
    );
};

export default ProjectDetails;
